import React from 'react';

const Label = ({ text }) => (
  <label className="text-sm font-semibold text-gray-700">{text}</label>
);

export default Label;
